import { Popper, Paper } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null;
  noOptionNode?: ReactNode;
}

export function NoOptionPopper({ anchorEl, open, noOptionNode }: Props): JSX.Element {
  return (
    <Popper sx={{ width: `${anchorEl?.offsetWidth}px`, zIndex: 2 }} open={open} anchorEl={anchorEl}>
      <Paper sx={{ padding: "1rem" }}>{noOptionNode ? noOptionNode : "No options available!"}</Paper>
    </Popper>
  );
}
